import './js/services/service-api';
import './js/pagination';
import './js/events/renderGalleryCard';

import './js/modal/modal';
import './js/modal/teamModal';

import './js/loader';

import './js/events/scrollUp';

import './js/services/search-by-keyword';
import './js/events/filter';
import './js/events/themeSwitcher';
import './js/events/preloader';

import '../node_modules/basiclightbox/dist/basicLightbox.min.css';
